import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthClientHelper } from './auth-client.helper';

@Injectable()
export class AuthGuardService {
    constructor(private router: Router, private _auth: AuthClientHelper) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Allow access to /recover-password for guests
        if (this._auth.isGuest() && state.url === '/recover-password') {
            return true;
        }

        // Allow access to /reset-password for guests, whether the token is present or not
        if (this._auth.isGuest() && state.url.startsWith('/reset-password')) {
            return true; 
        }

        // Redirect guest users trying to access other routes to /login
        if (this._auth.isGuest() && state.url !== '/login') {
            this.router.navigate(['/login']);
            return false;
        }

        // Redirect authenticated users trying to access /login to /home
        if (!this._auth.isGuest() && state.url === '/login') {
            this.router.navigate(['/home']);
            return false;
        }

        // Redirect users without level 1 access trying to access /admin to /home
        if (this._auth.user.value && this._auth.user.value.access_level !== 1 && state.url === '/admin') {
            this.router.navigate(['/home']);
            return false;
        }

        // Allow access for all other conditions
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/auth/auth-guard.helper.ts